import Text from '@jetbrains/ring-ui/components/text/text'
import classNames from 'classnames'
import {memo} from 'react'

import type {PipelineTextInfoProps} from './PipelineTextInfo.types'

import styles from './PipelineTextInfo.css'

function PipelineTextInfo({children, className}: PipelineTextInfoProps) {
  const classNameText = classNames(className, styles.container)

  return (
    <Text className={classNameText} info>
      {children}
    </Text>
  )
}

export default memo(PipelineTextInfo)
